import axios from '@/plugins/axios'

/**
 * Get invoices
 */
const getInvoices = async ({
  nfseApproval = null,
  nfseStatus = null,
  nfseIssuanceDateStart = null,
  nfseIssuanceDateEnd = null,
  orderBy = null,
  sort = null,
  paymentMethod = null,
  paymentStatus = null,
  page = 1,
  search = null
}) => {
  try {
    const params = {
      page: page
    }
    if (nfseApproval) params.nfse_approval = nfseApproval
    if (paymentStatus) params.payment_status = paymentStatus
    if (paymentMethod) params.payment_method = paymentMethod
    if (nfseStatus) params.nfse_status = nfseStatus
    if (nfseIssuanceDateStart) params.nfse_issuance_date_start = nfseIssuanceDateStart
    if (nfseIssuanceDateEnd) params.nfse_issuance_date_end = nfseIssuanceDateEnd
    if (orderBy) params.order_by = orderBy
    if (search) params.search = search
    if (sort) params.sort = sort
    const response = await axios.get('admin/invoices', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Update invoice payment status
 */
const updateInvoicePaymentStatus = async (id, {
  status
}) => {
  try {
    const response = await axios.post(`admin/invoices/${id}/payment-status`, {
      _method: 'PUT',
      status: status
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getInvoices,
  updateInvoicePaymentStatus
}
